function handleShopifyEditorEvent(fn) {
  const shopify_event_list = [
    'shopify:block:select',
    'shopify:block:deselect',
    'shopify:section:reorder',
    'shopify:section:select',
    'shopify:section:deselect',
    'shopify:section:load',
    'shopify:section:unload',
    'shopify:inspector:activate',
    'shopify:inspector:deactivate',
  ];

  if (!Shopify?.designMode) {
    return null;
  }

  return shopify_event_list?.map((event) => {
    document?.addEventListener(event, () => fn());
  });
}

function handlePageLoadEvent(callback) {
  const defaultEventName = 'DOMContentLoaded';
  const htmlElement = document.querySelector('html');
  
  if (!htmlElement) {
    return;
  }

  const { pageType } = htmlElement.dataset;
  const eventName = pageType === 'product' ? 'product-info:loaded' : defaultEventName;

  window.addEventListener(eventName, () => callback());
}